import React, { useState, useEffect } from "react";
import { Skeleton } from "antd";
import "./Skeleton.css";

const SkeletonProduct = () => {
	const [avatarSize, setAvatarSize] = useState({
		width: "250px",
		height: "250px",
	});
	const [titleWidth, setTitleWidth] = useState("94%");
	const [priceWidth, setPriceWidth] = useState("70%");
	const [priceWidthSecondary, setPriceWidthSecondary] = useState("40%");

	// Function to update sizes based on screen width
	const updateSizes = () => {
		const screenWidth = window.innerWidth;
		if (screenWidth <= 320) {
			setAvatarSize({ width: "135px", height: "120px" });
			setTitleWidth("75%");
			setPriceWidth("50%");
			setPriceWidthSecondary("20%");
		} else if (screenWidth <= 375) {
			setAvatarSize({ width: "150px", height: "120px" });
			setTitleWidth("75%");
			setPriceWidth("50%");
			setPriceWidthSecondary("20%");
		} else if (screenWidth <= 425) {
			setAvatarSize({ width: "182px", height: "140px" });
			setTitleWidth("80%");
			setPriceWidth("55%");
			setPriceWidthSecondary("25%");
		} else if (screenWidth <= 768) {
			setAvatarSize({ width: "160px", height: "180px" });
			setTitleWidth("85%");
			setPriceWidth("60%");
			setPriceWidthSecondary("30%");
		} else if (screenWidth <= 1024) {
			setAvatarSize({ width: "220px", height: "220px" });
			setTitleWidth("90%");
			setPriceWidth("65%");
			setPriceWidthSecondary("35%");
		} else {
			setAvatarSize({ width: "250px", height: "250px" });
			setTitleWidth("94%");
			setPriceWidth("70%");
			setPriceWidthSecondary("40%");
		}
	};

	// Update sizes on initial render and window resize
	useEffect(() => {
		updateSizes();
		window.addEventListener("resize", updateSizes);
		return () => window.removeEventListener("resize", updateSizes);
	}, []);

	return (
		<div className="SkeletonProduct">
			<Skeleton
				active
				paragraph={{ rows: 1 }}
				avatar={{
					size: "large",
					shape: "square",
					style: { ...avatarSize, marginBottom: "8px" },
				}}
			/>
			<Skeleton
				active
				title={{ width: titleWidth }}
				paragraph={false}
				className="SkeletonTitle"
			/>
			<Skeleton
				active
				title={{ width: priceWidth }}
				paragraph={false}
				className="SkeletonPrice"
			/>
			<Skeleton
				active
				title={{ width: priceWidthSecondary }}
				paragraph={false}
				className="SkeletonPrice"
			/>
		</div>
	);
};

export default SkeletonProduct;
